import React, { useEffect, useState } from "react";
import { Company } from "../company/Company";
import { CompanyImage } from "../company/Company.Image";
import { CompanyAPI } from "../company/CompanyAPI";
import { Loader } from "../components/common/Loader.component";
import { SearchTokenHelper } from "../helpers/Search.helper";
import { MainAndRightLayout } from "../layout/MainAndRight.Layout";
import { ListItemLayoutCard } from "../list/ListItem.Layout";
import { ListItemProps, ListV2 } from "../list/ListV2";
import { ReactMatch } from "../model/ReactMatchObj";
import { PageProps } from "../model/views/PageProps";
import { RelatedExpertsComponent } from "../promotion/RelatedExperts.Component";
import { Topic, TopicType } from "../topic/Topic.model";
import { QuestionDl } from "./Question.Dl";
import { Question } from "./Question.Model";
import { QuestionsAPI } from "./QuestionsAPI";
import { QuestionsFilterView } from "./QuestionsFilterView";
import { QuestionsListItem } from "./QuestionsList";

interface CompanyQuestionListPageContentPathParams {
  companyId: string;
}

interface CompanyQuestionListPageContentProps extends PageProps {
  match: ReactMatch<CompanyQuestionListPageContentPathParams>;
}

export function CompanyQuestionListPageContent(
  props: CompanyQuestionListPageContentProps
) {
  let companyId = props.match.params.companyId;
  let [company, setCompany] = useState<Company>();
  let [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    setLoading(true);
    CompanyAPI.getCompany(companyId)
      .executeV2()
      .then((company) => {
        setCompany(company);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [companyId]);

  let companyTopic: Topic = {
    topicId: { type: TopicType.COMPANY, id: companyId },
    topicType: TopicType.COMPANY,
    dl: "Company",
  };

  let companyToken = SearchTokenHelper.getTopicToken({
    topics: [companyTopic],
  });

  return (
    <div className="main-container bg-main-body CompanyQuestionListPageContent h-100">
      {loading && <Loader />}
      {company && (
        <div className="media mb-4">
          <CompanyImage company={company} />

          <div className={`media-body pl-4 mob-pl-3`}>
            <div className="d-flex w-100 justify-content-between">
              <h1 className="mb-1 h2">
                {company.desDl} Interview Questions - Shared by Candidates
              </h1>
            </div>
          </div>
        </div>
      )}
      <MainAndRightLayout
        gutter={[15, 10]}
        className="mt-3"
        main={
          <ListV2
            paginationPosition="bottom"
            user={props.user?.basicDetails}
            SearchComponent={QuestionsFilterView}
            initialStartingFilterToken={SearchTokenHelper.getAndToken([
              companyToken,
            ])}
            gutter={[10, 10]}
            onFetch={(searchRequest) => {
              return QuestionsAPI.search().executeV2(searchRequest ?? {});
            }}
            itemNode={(itemProps: ListItemProps) => {
              let question = itemProps.item as Question;
              return (
                <QuestionsListItem
                  question={question}
                  dl={
                    <span className="h5">
                      <QuestionDl ques={question} />
                    </span>
                  }
                  liu={props.user}
                />
              );
            }}
            emptyListContent="No questions found"
            ItemLayoutComponent={ListItemLayoutCard}
          />
        }
        right={
          <>
            {company && (
              <RelatedExpertsComponent
                context={{ topics: [company] }}
                className=""
              />
            )}
          </>
        }
      />
    </div>
  );
}
